import PropTypes from 'prop-types';
import { InformationIcon } from 'icons/solid';
import Tooltip from '../Tooltip/Tooltip';
import OrderInformation from '../../../../assets/invoice-order-tooltip.svg';
import TicketInformation from '../../../../assets/invoice-ticket-tooltip.svg';

const FormInvoiceInstructions = ({ context, isDesktop }) => {
    return (
        <>
            <div className='flex gap-x-2 bg-brand-primary-100 py-5 px-2 md:gap-0'>
                <div className='row-span-full block w-max md:hidden'>
                    <span>👀</span>
                </div>
                <div className='flex w-full flex-col gap-x-2 md:flex-row md:items-center'>
                    <div className='flex w-full md:w-max'>
                        <p className='m-0 flex w-full flex-col md:flex-row md:gap-x-1 md:text-sm'>
                            <strong className='flex gap-x-1'>
                                ¿Y dónde está eso, tú?
                                <span className='hidden md:flex'>👀</span>
                            </strong>
                        </p>
                    </div>
                    <div className='flex w-2/3 items-center justify-start text-start md:w-max'>
                        <span className='flex font-body text-xs md:w-full md:text-sm'>
                            {context === 'online'
                                ? 'Ntp, encuéntralos en tu correo de confirmación de compra 👉'
                                : 'Ntp, encuéntralos acá 👉'}
                        </span>
                        <Tooltip
                            uniqueId='ticket-information'
                            placement={isDesktop ? 'right' : 'bottom'}
                            anchorClassName='lg:ml-2 flex'
                            tooltipBgColor='bg-brand-primary-100'
                            arrowFillColor='fill-brand-primary-100'
                            tooltipContent={
                                <img
                                    src={
                                        context === 'online' ? OrderInformation : TicketInformation
                                    }
                                    alt='Ticket information'
                                />
                            }
                        >
                            <InformationIcon className='flex w-6' />
                        </Tooltip>
                    </div>
                </div>
            </div>
            <p className='text-start font-body-bold'>{`Buscar ${
                context === 'online' ? 'Pedido' : 'Ticket'
            }`}</p>
        </>
    );
};

FormInvoiceInstructions.defaultProps = {
    context: 'online',
};

FormInvoiceInstructions.propTypes = {
    context: PropTypes.oneOf(['online', 'offline', null]),
    isDesktop: PropTypes.bool,
};

export default FormInvoiceInstructions;
